var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeftNarrow = function SvgArrowLeftNarrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.813 16.813a1.15 1.15 0 0 1-1.627 0l-4-4a1.2 1.2 0 0 1-.2-.271 1.1 1.1 0 0 1-.114-.32 1.2 1.2 0 0 1-.017-.338q.016-.139.062-.266.028-.082.07-.16.01-.02.024-.041a1.2 1.2 0 0 1 .175-.23l4-4a1.15 1.15 0 0 1 1.627 1.626L6.12 10.508a.2.2 0 0 0 .141.341H21a1.15 1.15 0 0 1 0 2.301H6.26a.2.2 0 0 0-.141.342l1.694 1.694a1.15 1.15 0 0 1 0 1.627"
  })));
};
export default SvgArrowLeftNarrow;